import * as types from './types'
import storage from '@/plugins/storage'
export default {
  teams: [],
  team: {},
  activeTab: 'Profile',
  tabs: ['Profile', 'Certifications'],
  teamTree: [],
  selectedContactId: '',
  selectedId: 0,
  selectedTeamId: 0,
  selectedTeamName: '',
  selectedTeamMemberId: 0,
  selectedTeamMemberName: '',
  selectedTeamMemberProfile: {},
  selectedTeamMemberUsername: '',
  selectedTeamMembers: [],
  selectedTimeZone: '',
  teamMembers: [],
  teamMemberId: '',
  teamMemberIds: '',
  teamMemberProfile: {},
  teamMemberProfileId: '',
  selectedTimeZoneList: [],
  selectedLanguageList: [],
  selectedMakeList: [],
  selectedRegionList: [],
  selectedScanTypeCertificationList: [],
  selectedStateCertificationList: [],
  selectedTimeZoneValues: [],
  memberAttributeOptions: [],
  memberAttributeSelectedValues: [],
  memberAttributeLabel: '',
  attributes: [],
  uniqueAttributes: [],
  teamLead: {
    name: '',
    code: 0,
    id: 0
  },
  technicians: [],
  pageSize: storage.session.getItem(types.SESSION_PAGE_SIZE) || 10,
  searchTerm: storage.session.getItem(types.SESSION_SEARCH_TERM) || '',
  stateCertificationIds: [],
  isCertificationIddisabled: true
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/teams/state.js